import { React, PropTypes, Row, FelaComponent } from '../dependencies';

const rule = ({ theme }) => ({
    margin: '5px 0',
    padding: '5px 0',
    borderBottom: '1px dashed #BBB',
    fontSize: '16px',
    fontFamily: theme.fonts.menu,

    '&:first-child': {
        marginTop: '0',
    },
    '&:last-child': {
        marginBottom: '0',
        borderBottom: '0',
    },
});

const MenuItem = ({ data }) => (
    <FelaComponent rule={rule} render={({ className }) => <Row className={className}>{data.trim()}</Row>} />
);

MenuItem.propTypes = {
    data: PropTypes.string.isRequired,
};

export default MenuItem;
